import { defineAsyncComponent } from "vue";

export default {
	forms: {
		edit: {
			panel: {
				width: '70%'
			},
			component: defineAsyncComponent(() => import('./Edit.vue'))
		},
		list: {
			config: {},
			component: defineAsyncComponent(() => import('./List.vue'))
		}
	}
};

